import React from 'react';
import { Box, Flex, Text } from '@chakra-ui/react';
import { CheckIcon } from '@chakra-ui/icons';

const CustomCheckbox = ({ 
  isChecked, 
  onChange, 
  size = 'md',
  colorScheme = 'blue',
  mr = 2,
  ...props 
}) => {
  const handleClick = (e) => {
    e.stopPropagation();
    onChange(e);
  };

  const sizes = {
    sm: { box: '16px', icon: '12px' },
    md: { box: '20px', icon: '16px' },
    lg: { box: '24px', icon: '18px' }
  };

  return (
    <Box
      as="button"
      type="button"
      onClick={handleClick}
      display="inline-flex"
      alignItems="center"
      justifyContent="center"
      w={sizes[size].box}
      h={sizes[size].box}
      borderRadius="md"
      border="2px solid"
      borderColor={isChecked ? `${colorScheme}.500` : 'gray.300'}
      bg={isChecked ? `${colorScheme}.500` : 'white'}
      transition="all 0.2s"
      _hover={{
        borderColor: isChecked ? `${colorScheme}.600` : 'gray.400',
        bg: isChecked ? `${colorScheme}.600` : 'gray.50'
      }}
      _focus={{
        boxShadow: `0 0 0 3px ${colorScheme}.100`,
        outline: 'none'
      }}
      mr={mr}
      {...props}
    >
      {isChecked && (
        <CheckIcon 
          color="white" 
          boxSize={sizes[size].icon}
        />
      )}
    </Box>
  );
};

export default CustomCheckbox;